export const NEAR_EXPIRATION_DAYS = 7;

export const USER_LIST_DEFAULT_QUERY = {
  page: 1,
  limit: 10,
  search: '',
  planStatus: '',
  accountStatus: '',
  role: '',
  verified: '',
  sortBy: 'createdAt',
  sortOrder: 'desc',
};

const allowedValues = {
  planStatus: ['', 'active', 'near', 'expired'],
  accountStatus: ['', 'waiting', 'active', 'block'],
  role: ['', 'admin', 'client', 'operator', 'referral'],
  verified: ['', 'true', 'false'],
  sortBy: ['createdAt', 'lastLogin', 'username'],
  sortOrder: ['asc', 'desc'],
};

const getPositiveInteger = (value, fallback, maximum) => {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) return fallback;
  return Math.min(parsed, maximum);
};

export const getUserListQueryFromSearch = searchString => {
  const params = new URLSearchParams(searchString || '');
  const query = {
    ...USER_LIST_DEFAULT_QUERY,
    page: getPositiveInteger(params.get('page'), 1, Number.MAX_SAFE_INTEGER),
    limit: getPositiveInteger(params.get('limit'), 10, 100),
    search: String(params.get('search') || '').trim().slice(0, 100),
  };

  Object.keys(allowedValues).forEach(key => {
    const value = params.get(key);
    if (value !== null && allowedValues[key].includes(value)) query[key] = value;
  });

  return query;
};

export const getUserListSearchFromQuery = query => {
  const params = new URLSearchParams();
  const normalized = { ...USER_LIST_DEFAULT_QUERY, ...query };

  Object.keys(normalized).forEach(key => {
    const value = normalized[key];
    if (value === USER_LIST_DEFAULT_QUERY[key] || value === '') return;
    params.set(key, String(value));
  });

  const result = params.toString();
  return result ? `?${result}` : '';
};

export const getEffectiveUserSearch = value => {
  const normalized = String(value || '').trim();
  if (normalized.length > 0 && normalized.length < 3) return null;
  return normalized;
};

export const getPlanView = planSummary => {
  if (!planSummary) {
    return {
      status: 'none',
      name: '-',
      days: '',
    };
  }

  const remainingDays = Number(planSummary.remainingDays || 0);
  const planName = planSummary.planLabel || 'Free';

  if (remainingDays > NEAR_EXPIRATION_DAYS) {
    return {
      status: 'active',
      name: planName,
      days: `${remainingDays} days`,
    };
  }

  if (remainingDays > 0) {
    return {
      status: 'near',
      name: planName,
      days: `${remainingDays} days`,
    };
  }

  return {
    status: 'expired',
    name: planName,
    days: remainingDays === 0
      ? 'Ended today'
      : `${Math.abs(remainingDays)} days ago`,
  };
};
